<template>
  <zg-module
    v-bind="moduleProps"
    class="zg-article-preview-section"
  >
    <slot
      slot="sub-title"
      name="sub-title"
    />

    <div
      v-if="articles && articles.length"
      :class="['zg-article-preview-section', {[`zg-article-preview-section--${gridType}`]: !!gridType}]"
    >
      <zg-article-preview
        v-for="(article, index) in articles"
        :key="index"
        :tabindex="index"
        :item-size="['large', 'medium'].includes(gridType) && index > 0 ? 'small' : null"
        :grid-type="gridType"
        :background="cardBackground"
        v-bind="article"
        :lazy-load="lazyLoad || article.lazyLoad"
      />
    </div>
  </zg-module>
</template>

<script>
  import module from '../../../mixins/module.js'
  import ZgArticlePreview from '../../ZgArticlePreview/ZgArticlePreview.vue'
  import ZgModule from '../ZgModule/ZgModule.vue'

  export default {
    name: 'ZgArticlePreviewSection',
    components: {
      ZgModule,
      ZgArticlePreview
    },
    mixins: [module],
    props: {
      articles: {
        type: Array,
        required: true,
        default: () => []
      },
      gridType: {
        type: String,
        default: 'grid',
        validator: value => [
          'large',
          'medium',
          'grid'
        ].includes(value)
      },
      lazyLoad: {
        type: Boolean,
        default: false
      }
    }
  }
</script>
<style scoped lang="scss">
  .zg-article-preview-section {
    display: grid;

    &--large,
    &--medium {
      grid-template-columns: 1fr;
    }

    &--large {
      grid-row-gap: rhythm(medium);

      @include mq(large) {
        grid-template-columns: 2fr 1fr;
        grid-template-rows: auto;
        grid-column-gap: rhythm(x-large);

        a:first-child,
        article:first-child {
          grid-area: 1 / 1 / 4 / 2;
        }
      }
    }

    &--medium {
      grid-row-gap: rhythm(medium);

      @include mq(large) {
        grid-template-columns: 1fr 2fr;
        grid-template-rows: repeat(3, auto);
        grid-column-gap: rhythm(double);

        a:first-child,
        article:first-child {
          grid-area: 1 / 1 / 4 / 2;
        }
      }
    }

    &--grid {
      gap: rhythm(base);

      @include mq(large) {
        grid-template-columns: repeat(3, 1fr);
      }
    }
  }
</style>
